import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'apollo',
  `
    STORAGE_SAVE_INIT
    STORAGE_SAVE_SUCCESS
    STORAGE_SAVE_ERROR

    APOLLO_LINK_STATE_SYNC
  `
);
